import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

describe('UsageRecords', () => {
  test('renders', async() => {
    render(<Index/>);
    // タイトル
    expect(screen.getByText('利用実績出力')).toBeInTheDocument();
    // 項目名
    expect(screen.getByText('出力期間')).toBeInTheDocument();
    expect(screen.getByText('チケット購入数')).toBeInTheDocument();
    expect(screen.getByText('ビデオ通話回数')).toBeInTheDocument();
    // ボタン
    expect(screen.queryAllByText('CSV出力')[0]).toBeInTheDocument();
    expect(screen.queryAllByText('CSV出力')[1]).toBeInTheDocument();
  });  
});

